module.exports = __webpack_public_path__ + "media/images/katniss-b0fbaa4bc7b707b3247c789117bd1cd8.png";